import React, { Fragment, useState } from "react";
import type { FC, PropsWithChildren } from "react";
import TextBox from "./TextBox.module.css";

type InputBoxProps = PropsWithChildren<{
  className?: string;
  icon?: string;
  icon2?: string;
  type?: string;
  value: string;
  label?: string;
  locked?: boolean;
  disabled?: boolean;
  placeholder: string;
  errorMessage?: string;
  defaultValue?: string;
  style?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
  inputContainerStyle?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClickIcon1?: React.MouseEventHandler<SVGSVGElement>;
  onClickIcon2?: React.MouseEventHandler<SVGSVGElement>;
  info_icon?: string;
  info_description?: string;
  inputContainerClass?:string
  inputClass?:string,
  labelClass?:string
}>;

const InputBox: FC<InputBoxProps> = ({
  info_description,
  info_icon,
  className,
  type = "text",
  placeholder,
  value,
  onChange,
  errorMessage,
  label,
  icon,
  icon2,
  style,
  containerStyle,
  inputContainerStyle,
  labelStyle,
  disabled,
  defaultValue,
  locked,
  onClickIcon1,
  onClickIcon2,
  inputContainerClass,
  inputClass,
  labelClass
}) => {
  const [inputType, setInputType] = useState(type);
  const [showTooltip, setShowTooltip] = useState(false);
  const handlePasswordView = () => {
    if (type === "password") {
      if (inputType === "text") setInputType("password");
      else setInputType("text");
    }
  };

  const getTodaysDate = () => {
    let today = new Date();
    let dd = today.getDate();
    let mm = String(today.getMonth() + 1).padStart(2, "0");
    let yyyy = today.getFullYear();

    return yyyy + "-" + mm + "-" + dd;
  };

  return (
    <div
      className={`${TextBox.form_input} ${className || ""}`}
      style={containerStyle}
    >
      <div style={{ display: "flex" }}>
        {label && (
          <label
            htmlFor={label}
            className={`${TextBox.form_input__label} ${labelClass}`}
            style={labelStyle}
          >
            {label}
          </label>
        )}
        {info_icon && (
          <div
            className={TextBox.form_input__infoIcon}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            <svg className={TextBox.form_input__icon}>
              <use xlinkHref={`/assets/sprite.svg#icon-info`} />
            </svg>
            {showTooltip && (
              <div className={TextBox.tooltip}>{info_description}</div>
            )}
          </div>
        )}
      </div>

      <div
        className={`${TextBox.form_input__container} ${inputContainerClass}`}
        style={inputContainerStyle || style}
      >
        {icon && (
          <svg className={TextBox.form_input__icon} onClick={onClickIcon1}>
            <use xlinkHref={`/assets/sprite.svg#icon-${icon}`} />
          </svg>
        )}
        {icon2 && (
          <svg className={TextBox.form_input__icon} onClick={onClickIcon2}>
            <use xlinkHref={`/assets/sprite.svg#icon-${icon2}`} />
          </svg>
        )}
        {!locked ? (
          <Fragment>
            <input
              type={inputType}
              id={label}
              disabled={disabled ? disabled : false}
              placeholder={placeholder}
              value={value}
              defaultValue={defaultValue}
              onChange={onChange}
              className={`${TextBox.form_input__box} ${inputClass}`}
              max={type === "date" ? getTodaysDate() : ""}
              style={style}
            />
            {type === "password" && (
              <svg
                className={TextBox.form_input__icon}
                onClick={handlePasswordView}
              >
                <use
                  xlinkHref={`/assets/sprite.svg#icon-${
                    inputType === "text" ? "visibility_off" : "visibility"
                  }`}
                />
              </svg>
            )}
          </Fragment>
        ) : (
          <Fragment>
            <p
              className={TextBox.form_input__box}
              style={{
                height: "1.5rem",
                lineHeight: "1",
                color: value ? "var(--grey)" : "var(--light-grey)",
                ...(style || {}),
              }}
            >
              {value ? value : placeholder}
            </p>
            <svg className={TextBox.form_input__icon}>
              <use xlinkHref={`/assets/sprite.svg#icon-lock`} />
            </svg>
          </Fragment>
        )}
      </div>
      {errorMessage && (
        <p className={TextBox.form_input__error}>{errorMessage}</p>
      )}
    </div>
  );
};

export default InputBox;
